import React, { SVGProps } from 'react'
const SvgCardNew = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    viewBox={'0 0 20 21'}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M18.3333 8.93351H1.66663M9.16663 12.2668H4.99996M1.66663 7.43351L1.66663 13.7668C1.66663 14.7003 1.66663 15.167 1.84828 15.5235C2.00807 15.8371 2.26304 16.0921 2.57664 16.2519C2.93316 16.4335 3.39987 16.4335 4.33329 16.4335L15.6666 16.4335C16.6 16.4335 17.0668 16.4335 17.4233 16.2519C17.7369 16.0921 17.9919 15.8371 18.1516 15.5235C18.3333 15.167 18.3333 14.7003 18.3333 13.7668V7.43351C18.3333 6.50009 18.3333 6.03338 18.1516 5.67686C17.9919 5.36326 17.7369 5.10829 17.4233 4.9485C17.0668 4.76685 16.6 4.76685 15.6666 4.76685L4.33329 4.76685C3.39987 4.76685 2.93316 4.76685 2.57664 4.9485C2.26304 5.10829 2.00807 5.36326 1.84828 5.67686C1.66663 6.03338 1.66663 6.50009 1.66663 7.43351Z"
      fill="none"
      stroke={props.fill || 'var(--color-cta)'}
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgCardNew
